import {matchPath} from 'react-router-dom';
import {ROUTES} from '@/config/routesConstants';

function getCampaignIdFromPathname(pathname: string): string | undefined {
  const match =
    matchPath(`${ROUTES.CAMPAIGNS_V2}/:campaignId/*`, pathname) ??
    matchPath(`${ROUTES.CAMPAIGNS}/:campaignId/*`, pathname);
  return match?.params.campaignId;
}

export default getCampaignIdFromPathname;
